import { useLang } from "@/context/LanguageContext";
import { METHOD_IMG } from "@/data/content";
import { Reveal, Overline } from "@/components/shared";

export const Method = () => {
  const { t } = useLang();
  const m = t.method;

  return (
    <section id="method" data-testid="method" className="relative overflow-hidden border-t border-zinc-800 bg-zinc-950">
      <div className="absolute inset-0 opacity-20">
        <img src={METHOD_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/80 to-zinc-950/60" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 py-24 sm:px-12 md:py-32">
        <div className="max-w-3xl">
          <Reveal>
            <Overline dark>{m.overline}</Overline>
            <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-white sm:text-5xl">
              {m.title}
            </h2>
            <p className="mt-8 text-base leading-relaxed text-zinc-400 sm:text-lg">{m.body}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-zinc-800 bg-zinc-800 sm:grid-cols-2 lg:grid-cols-4">
          {m.tools.map((tool, i) => (
            <Reveal key={tool.name} i={i}>
              <div
                data-testid="method-tool"
                className="group h-full bg-zinc-950 p-8 transition-colors hover:bg-zinc-900"
              >
                <span className="font-mono text-xs text-zinc-600">{`{ ${String(i + 1).padStart(2, "0")} }`}</span>
                <h3 className="mt-6 font-heading text-xl font-medium text-white">{tool.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-500">{tool.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
